import { IGetProdutoServicoEsDropDownUseCase } from "../../../presentation/useCases/read/get_produto_servico_estoque_drop_down_use_case";
import { DropDown } from "../../models/dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

export class GetProdutoServicoEsDropDownUseCase implements IGetProdutoServicoEsDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getProdutoServicoEsDropDown(IdControleEstoque: number): Promise<DropDown[]> {
    return await this.repository.getProdutoServicoEsDropDown(IdControleEstoque);
  }
}
